import type { ScaleLinear, ScaleTime } from 'd3-scale';

import { useAxisFormatter } from './axis/hooks/useAxisFormatter.js';
import { isNumericalScale } from './axis/types/annotations-x-axis-props.js';
import type { BehaviorTrackingProps } from '../../../core/types/behavior-tracking-props.js';
import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { AnnotationsNumericalDisplay } from '../../core/components/annotations/components/displays/AnnotationsNumericalDisplay.js';
import { AnnotationsTimeDisplay } from '../../core/components/annotations/components/displays/AnnotationsTimeDisplay.js';
import type { AnnotationsTooltipConfig } from '../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';
import type { AnnotationsTrackConfig } from '../../core/components/annotations/types/annotations-track-props.js';
import type { AnnotationsActionsHandler } from '../../core/components/annotations/types/annotations.js';
import type { TextOverflowOptions } from '../../core/components/annotations/types/marker.js';

type AnnotationsDisplayProps = BehaviorTrackingProps & {
  scale: ScaleTime<number, number> | ScaleLinear<number, number>;
  tracks: AnnotationsTrackConfig[];
  annotationsActions?: AnnotationsActionsHandler;
  showLabels: boolean;
  labelsOffset: number;
  width: number;
  tooltipConfig: AnnotationsTooltipConfig;
  textOverflow: TextOverflowOptions;
  truncateMode?: TruncationMode;
  maxLines?: number;
};

export const AnnotationsDisplay = (props: AnnotationsDisplayProps) => {
  const { scale, ...remaining } = props;

  const formatter = useAxisFormatter();

  return isNumericalScale(scale) ? (
    <AnnotationsNumericalDisplay
      scale={scale}
      {...remaining}
      formatter={formatter}
    />
  ) : (
    <AnnotationsTimeDisplay scale={scale} {...remaining} />
  );
};
